import "./style.less";

export default function BasketAside() {
    return {
        restrict: "E",
        scope: {
            layout: "=",
            menuItemClass: "@",
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            $route,
            $timeout,
            siteService,
            Basket,
            // BasketStorage,

            localStorageService,
            asideFactory
        ) {
            // Bookings counter
            $scope.selectedBookings = Basket.currentBookings;

            // Used to prevent the basket to display in the booking flow
            // Must have this vaiable set as true in all checkout controllers
            $scope.currentPageCheckout = $route.current.$$route.checkout;

            var routeChangeSuccessEventListener = $rootScope.$on(
                "$routeChangeSuccess",
                function () {
                    // avail params : event, currentRoute,  previousRoute
                    // Update the Bookings counter
                    $scope.selectedBookings = Basket.currentBookings;

                    $timeout(function () {
                        $scope.currentPageCheckout =
                            $route.current.$$route.checkout;
                    });
                }
            );
            $scope.$on("$destroy", routeChangeSuccessEventListener);

            /************************
             *
             * EVENTS
             **/

            var openBasketEventListener = $scope.$on(
                "open-basket",
                function () {
                    //avail params event
                    $scope.openAside(null, "right", true, null, null);
                }
            );
            $scope.$on("$destroy", openBasketEventListener);

            var bookingAddedEventListener = $scope.$on(
                "booking-added-to-basket",
                function () {
                    //avail params event
                    $scope.openAside(null, "right", true, null, null);
                }
            );
            $scope.$on("$destroy", bookingAddedEventListener);

            // When user has clikced book now -> but is denied because of declined bookings
            var declinedBookingsEventListener = $scope.$on(
                "declined-bookings",
                function (event, declinedBookings) {
                    $scope.openAside(
                        null,
                        "right",
                        true,
                        declinedBookings,
                        null
                    );
                }
            );
            $scope.$on("$destroy", declinedBookingsEventListener);

            /**
             * args.reapeatedBooking - booking obj
             * args.foundPattern bool
             */
            var OpenAsideThenRepeatableEventListener = $scope.$on(
                "open-aside-then-repeaetable-tooltip",
                function (event, args) {
                    if (args.repeatedBooking) {
                        $scope.openAside(
                            null,
                            "right",
                            true,
                            null,
                            args.repeatedBooking
                        );
                    }
                }
            );
            $scope.$on("$destroy", OpenAsideThenRepeatableEventListener);

            /**
             * [openAside description]
             * @param  {[type]} $event           [description]
             * @param  {[type]} position         [description]
             * @param  {[type]} backdrop         [description]
             * @param  {[type]} declinedBookings [description]
             * @param  {[type]} repeatedBooking  [description]
             * @return {[type]}                  [description]
             */
            $scope.openAside = function (
                $event,
                position,
                backdrop,
                declinedBookings,
                repeatedBooking
            ) {
                if ($event) {
                    $scope.closeTooltip($event);
                    $event.preventDefault();
                }

                asideFactory.open(
                    $event,
                    position,
                    backdrop,
                    declinedBookings,
                    repeatedBooking
                );
                // .then(
                //     (res) => {
                //         console.log(res);
                //     },
                //     (err) => {
                //         console.log(err);
                //     }
                // );
            };

            /***************************************************************************
             * toggleBasketTooltip - Disabled in advance for - always open aside basket when user adds a booking
             ***************************************************************************/

            var basketTooltipEventListener = $scope.$on(
                "basket-tooltip-broadcast",
                function () {
                    // debug function (always display the tooltip)
                    // localStorageService.remove('preventbaskettooltip');

                    if (
                        localStorageService.get("preventbaskettooltip") !==
                        "true"
                    ) {
                        // $scope.toggleBasketTooltip(); // Disabled in advance for : always open aside basket when user adds a booking
                    }
                }
            );
            $scope.$on("$destroy", basketTooltipEventListener);

            $scope.toggleBasketTooltip = function () {
                if (Basket.currentBookings.length == 1) {
                    $scope.showBasketTooltip = true;

                    localStorageService.set("preventbaskettooltip", true);
                } else {
                    $scope.showBasketTooltip = false;
                }
            };

            $scope.closeTooltip = function ($event) {
                $event.stopPropagation(); /// prevent click on parent data-ng-clicks - In this case opening "Aside right"

                $scope.showBasketTooltip = false;
            };
        },
    };
}
